import Builder from '@app/store/builder';
var STATE = Builder.state({
    isOpen: false,
}, 'Search');
var MUTATIONS = {
    setOpenState: function (open) {
        if (open) {
            document.body.classList.add('js-active');
        }
        else {
            document.body.classList.remove('js-active');
        }
        STATE.isOpen = open;
    }
};
var ACTIONS = {
    open: function () {
        MUTATIONS.setOpenState(true);
    },
    close: function () {
        MUTATIONS.setOpenState(false);
    },
    toggle: function () {
        MUTATIONS.setOpenState(!STATE.isOpen);
    }
};
export default {
    STATE: STATE,
    MUTATIONS: MUTATIONS,
    ACTIONS: ACTIONS
};
